// دوال المشاركة/النسخ لنوافذ التقارير — الأزرار تظهر في الأعلى فقط (بلا تكرار في الأسفل).
export const shareBar = (url, copied = "✓") => {
  if (!url) return "";
  return `<script>
  async function shareReport(url, title) {
    if (navigator.share) {
      try { await navigator.share({ url: url }); return; }
      catch (e) { if (e && e.name === 'AbortError') return; }
    }
    copyReportLink(url);
  }
  async function copyReportLink(url) {
    try { await navigator.clipboard.writeText(url); }
    catch (e) {
      var ta = document.createElement('textarea');
      ta.value = url; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } finally { document.body.removeChild(ta); }
    }
    alert(${JSON.stringify(copied)});
  }
  </script>`;
};
